module.exports = __webpack_public_path__ + "static/img/wycs@2x.76ff35ae.png";